import {CreateDirectories, createFileListItem, gaEvent, gaException, isSafeFile, safeFilename, pause} from './Utils'  // eslint-disable-line
export default class EditService {
    archiveFileName = null;
    worker;
    processing = false;
    
    fileList;
    fileListError;
    extractedFile;
    extractedFileError;

    directories = new Set();    
    filter;
    unfilteredCount;    
    dbxService;
    encrypted = false;
    password;
    extractor;

    constructor(archiveFile) {
        console.log('TODO', archiveFile);

        // PROD worker
        // this.worker = new Worker('/assets/7z-wasm/ew.js'); 
        
        // DEV worker
        //this.worker = new Worker('/assets/7z-wasm/edit-worker.js');
    }

    getFileList() {
        console.log('TODO');
    }

    addFile() {
        console.log('TODO');
    }

    removeFile() {
        console.log('TODO');
    }

    addDirectory() {
        console.log('TODO');
    }

    removeDirectory() {
        console.log('TODO');
    }







}